var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.43 93.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m82.55,93.8c-1.01-.02-22.51-.03-39.81-.04-12.12,0-22.59,0-22.88-.02-.14,0-.23,0-.31,0-.13,0-.22,0-.31-.01-3.29-.18-5.79-1.78-7.64-4.87-.91-1.52-1.35-3.2-1.35-5.14,0-6.96,0-13.92,0-20.88v-12.9c0-.37.02-.74.03-1.11.01-.25.02-.51.03-.76,0-.11-.02-.21-.04-.33l-.04-.21-.1-.63-.71.62c-.15.13-.28.24-.4.36l-1.41,1.41c-.79.79-1.58,1.59-2.38,2.38-.69.68-1.43,1.01-2.28,1.01-.08,0-.15,0-.23,0-.8-.05-1.56-.47-2.08-1.15-.53-.69-.75-1.56-.59-2.37.17-.89.68-1.55,1.4-2.26l3.23-3.21c1.81-1.8,3.62-3.59,5.42-5.39,6.38-6.36,12.75-12.73,19.13-19.1L46.15,2.29C47.61.83,49.05.11,50.7.02c.17-.01.33-.02.5-.02,1.68,0,3.1.53,4.23,1.58,2.09,1.95,4.09,3.92,5.78,5.6,2.3,2.28,4.59,4.58,6.88,6.88,0,0,17.39,17.43,17.78,17.82,4.82,4.79,9.62,9.58,14.43,14.38.52.52,1.12,1.11,1.6,1.76.83,1.11.71,2.72-.29,3.74-.57.59-1.37.93-2.18.93-.56,0-1.1-.16-1.56-.46-.32-.21-.65-.49-1.04-.88-.82-.81-1.63-1.63-2.44-2.45l-1.22-1.23c-.07-.07-.15-.13-.26-.22l-.72-.59-.05.95c-.01.15-.02.27-.02.39v7.82c.01,9.28.02,18.56.03,27.84,0,4.72-3.26,8.85-7.77,9.81-.38.08-.78.1-1.21.11-.2,0-.4.01-.61.03Zm-1.52-5.97c.41,0,.81,0,1.22-.01,2.24-.06,3.75-1.6,3.75-3.83,0-14.3,0-28.59,0-42.89,0-.33-.17-.72-.4-.96-7.14-7.14-14.29-14.28-21.44-21.42l-11.17-11.16c-.32-.32-.63-.67-.96-1.05l-.81-.91-.68.78c-.23.27-.42.49-.63.7l-8.75,8.74c-8.11,8.1-16.23,16.2-24.33,24.31-.27.27-.4.7-.4,1-.02.66,0,1.31,0,1.97,0,.38,0,.75,0,1.13l-.02,39.91c0,1.76,1.09,3.15,2.77,3.55.53.13,1.08.14,1.56.14h57.98s2.32,0,2.32,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    x: 57.24,
    y: 64.42,
    width: 8.54,
    height: 8.58
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    x: 57.27,
    y: 46.39,
    width: 8.55,
    height: 8.57
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    x: 36.62,
    y: 46.4,
    width: 8.54,
    height: 8.56
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    x: 36.63,
    y: 64.44,
    width: 8.54,
    height: 8.55
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.421224a424cab02a7368069993b36e4e.svg";
export { ForwardRef as ReactComponent };